import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

type Params = Pick<ChallengeFormType, 'purchaseChannel'>;

export const validate: FormValidator<Params> = () => {
  return { isValid: true };
};
